import { getMethodInstance } from "../Subscription/api";

export const subscriptionRenew = (token) =>
  getMethodInstance(`subscription-renew/${token}`);
